export const MODIFY_DB_INFO = 'MODIFY_DB_INFO';

export function modifyDBInfo(dbInfo){
    return{
        type: MODIFY_DB_INFO,
        mainState: {
            dbInfo: dbInfo
        }
    }
}